// ======================================================================
// 📁 ToolsAssignmentCard.js
// PURPOSE:
//   Tool selection & assignment (Planning – Drawer)
// ======================================================================

import React, { useState } from "react";

export default function ToolsAssignmentCard({
  availableTools = [],
  selectedTools = [],

  // ✅ new refactored handler
  onChange,

  // 🔁 legacy-safe handlers
  onAddTool,
  onRemoveTool,
}) {
  const [selectedToolId, setSelectedToolId] = useState("");

  // ------------------------------------------------------------
  // ✅ unified emitter
  // ------------------------------------------------------------
  const emitChange = (tools) => {
    if (typeof onChange === "function") {
      onChange({ tools });
      return;
    }

    // legacy fallback
    if (typeof onAddTool === "function") {
      tools.forEach((t) => onAddTool(t.tool_id));
    }
  };

  // ------------------------------------------------------------
  // normalize ids
  // ------------------------------------------------------------
  const toolIds = selectedTools.map((t) =>
    typeof t === "object" ? t.tool_id : t
  );

  const available = availableTools.filter(
    (t) => !toolIds.includes(t.tool_id)
  );

  return (
    <div className="card ppe-card mb-3">
      <div className="card-header">Tools</div>

      <div className="card-body">
        {/* ADD TOOL */}
        <div className="d-flex gap-2 mb-3">
          <select
            className="form-select"
            value={selectedToolId}
            onChange={(e) => setSelectedToolId(e.target.value)}
          >
            <option value="">Select Tool</option>
            {available.map((t) => (
              <option key={t.tool_id} value={t.tool_id}>
                {t.tool_name}
              </option>
            ))}
          </select>

          <button
            className="btn btn-outline-primary"
            disabled={!selectedToolId}
            onClick={() => {
              const tool = availableTools.find(
                (t) => t.tool_id === Number(selectedToolId)
              );

              if (!tool) return;

              const updated = [
                ...selectedTools,
                {
                  tool_id: tool.tool_id,
                  tool_name: tool.tool_name,
                },
              ];

              emitChange(updated);
              setSelectedToolId("");
            }}
          >
            Add Tool
          </button>
        </div>

        {/* SELECTED TOOLS */}
        {selectedTools.length === 0 && (
          <div className="text-muted small">
            No tools assigned
          </div>
        )}

        {selectedTools.map((tool) => (
          <div
            key={tool.tool_id}
            className="d-flex justify-content-between align-items-center border rounded px-3 py-2 mb-2"
          >
            <span>{tool.tool_name}</span>

            <button
              className="btn btn-sm btn-outline-danger"
              onClick={() => {
                const updated = selectedTools.filter(
                  (t) => t.tool_id !== tool.tool_id
                );

                emitChange(updated);

                if (typeof onRemoveTool === "function") {
                  onRemoveTool(tool.tool_id);
                }
              }}
            >
              ✕
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
